"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionContent = ActionContent;

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _data = require("../data");

var _hooks = require("../hooks");

var _description = require("../ui/description");

var _header = require("../ui/header");

var _heroMeta = require("../ui/heroMeta");

var _meta = require("../ui/meta");

var _base = require("./base");

var _costTypeName,
    _dec,
    _dec2,
    _dec3,
    _dec4,
    _dec5,
    _dec6,
    _dec7,
    _dec8,
    _dec9,
    _dec10,
    _class,
    _descriptor,
    _descriptor2,
    _descriptor3,
    _descriptor4,
    _descriptor5,
    _descriptor6,
    _descriptor7,
    _descriptor8,
    _descriptor9,
    _descriptor10,
    _temp,
    _jsxFileName = "/home/ackwell/code/xivanalysis/tooltips/src/detail/action.tsx";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var CAST_TIME_FACTOR = 0.1;
var MANA_COST_FACTOR = 100;
var MELEE_RANGE = 3;
var CostType;

(function (CostType) {
  CostType[CostType["MP"] = 3] = "MP";
  CostType[CostType["GP"] = 7] = "GP";
})(CostType || (CostType = {}));

var addonIds = {
  instant: {
    id: 699,
    "default": 'Instant'
  },
  cast: {
    id: 701,
    "default": 'Cast'
  },
  recast: {
    id: 702,
    "default": 'Recast'
  },
  mpCost: {
    id: 705,
    "default": 'MP Cost'
  },
  gpCost: {
    id: 708,
    "default": 'GP Cost'
  },
  range: {
    id: 709,
    "default": 'Range'
  },
  radius: {
    id: 710,
    "default": 'Radius'
  },
  acquired: {
    id: 711,
    "default": 'Acquired'
  },
  affinity: {
    id: 712,
    "default": 'Affinity'
  }
};
var costTypeName = (_costTypeName = {}, (0, _defineProperty2["default"])(_costTypeName, CostType.MP, 'mpCost'), (0, _defineProperty2["default"])(_costTypeName, CostType.GP, 'gpCost'), _costTypeName);
var ActionData = (_dec = (0, _data.column)('ActionCategory.Name'), _dec2 = (0, _data.column)('Range'), _dec3 = (0, _data.column)('EffectRange'), _dec4 = (0, _data.column)('Cast100ms'), _dec5 = (0, _data.column)('Recast100ms'), _dec6 = (0, _data.column)('PrimaryCostType'), _dec7 = (0, _data.column)('PrimaryCostValue'), _dec8 = (0, _data.column)('ClassJob.Abbreviation'), _dec9 = (0, _data.column)('ClassJobLevel'), _dec10 = (0, _data.column)('ClassJobCategory.Name'), (_class = (_temp = /*#__PURE__*/function (_BaseData) {
  (0, _inherits2["default"])(ActionData, _BaseData);

  var _super = _createSuper(ActionData);

  function ActionData() {
    var _this;

    (0, _classCallCheck2["default"])(this, ActionData);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _initializerDefineProperty2["default"])(_this, "category", _descriptor, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "range", _descriptor2, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "radius", _descriptor3, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "castTime", _descriptor4, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "recastTime", _descriptor5, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "costType", _descriptor6, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "cost", _descriptor7, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "learntBy", _descriptor8, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "learntAt", _descriptor9, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "affinity", _descriptor10, (0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  return ActionData;
}(_base.BaseData), _temp), (_descriptor = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "category", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "range", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "radius", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "castTime", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "recastTime", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "costType", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "cost", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "learntBy", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "learntAt", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "affinity", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));

function ActionContent(_ref) {
  var _data$name;

  var id = _ref.id,
      onUpdate = _ref.onUpdate;
  var data = (0, _hooks.useGameData)({
    sheet: 'Action',
    columns: ActionData,
    id: id
  }); // Each time data is modified, trip update effect

  (0, _react.useEffect)(function () {
    return onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate();
  }, [onUpdate, data]);
  var strings = (0, _hooks.useAddonStrings)({
    ids: addonIds
  });
  var headerMeta = data && getHeaderMeta(data, strings);
  var meta = data && getMeta(data, strings);
  var heroMeta = data && getHeroMeta(data, strings);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_header.Header, {
    title: (_data$name = data === null || data === void 0 ? void 0 : data.name) !== null && _data$name !== void 0 ? _data$name : 'Loading',
    subtitle: data === null || data === void 0 ? void 0 : data.category,
    icon: (data === null || data === void 0 ? void 0 : data.icon) && /*#__PURE__*/_react["default"].createElement("img", {
      src: data.icon,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 84,
        columnNumber: 25
      }
    }),
    meta: headerMeta,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 81,
      columnNumber: 4
    }
  }), heroMeta && /*#__PURE__*/_react["default"].createElement(_heroMeta.HeroMeta, {
    items: heroMeta,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 87,
      columnNumber: 17
    }
  }), (data === null || data === void 0 ? void 0 : data.description) && /*#__PURE__*/_react["default"].createElement(_description.Description, {
    html: data.description,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 88,
      columnNumber: 26
    }
  }), meta && /*#__PURE__*/_react["default"].createElement(_meta.Meta, {
    items: meta,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 13
    }
  }));
}

var getHeaderMeta = function getHeaderMeta(data, strings) {
  return [{
    name: strings.range,
    value: data.range == -1 ? MELEE_RANGE : data.range
  }, {
    name: strings.radius,
    value: data.radius
  }];
};

var getMeta = function getMeta(data, strings) {
  return [{
    name: strings.acquired,
    value: "".concat(data.learntBy, " Lv. ").concat(data.learntAt)
  }, {
    name: strings.affinity,
    value: data.affinity
  }];
};

function getHeroMeta(data, strings) {
  var stats = [{
    name: strings.cast,
    value: formatCastTime(data.castTime, strings)
  }]; // Don't display recast if it's 0

  if (data.recastTime > 0) {
    stats.push({
      name: strings.recast,
      value: formatCastTime(data.recastTime, strings)
    });
  } // Only display costs if it's a known cost type - cost gets used
  // for features like gauge as well


  if (data.cost > 0 && CostType[data.costType] != null) {
    // Mana needs to be multiplied up for some dumb reason
    var value = data.costType === CostType.MP ? data.cost * MANA_COST_FACTOR : data.cost;
    stats.push({
      name: strings[costTypeName[data.costType]],
      value: value
    });
  }

  return stats;
}

var formatCastTime = function formatCastTime(time, strings) {
  return time == 0 ? strings.instant : (time * CAST_TIME_FACTOR).toFixed(2) + 's';
};